<template>
    <CategoriesForm
        :is-new="false"
        heading="Edit category"
        api-base="product-categories"
        url-base="/products/categories"
    />
</template>

<script>
import CategoriesForm from '../../components/categories/CategoriesForm.vue';

export default {
    components: {
        CategoriesForm,
    },
};
</script>
